import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { PdpSharedMakerHeadshotModule } from './PdpSharedMakerHeadshotModule/PdpSharedMakerHeadshotModule';
import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function PdpSharedDescriptionAboutMakerComponent(props) {
    const { headerClass, contentClass, item } = props;
    const liveStorefront = get(item, 'seller.liveStorefrontProfile') || {};

    if (!liveStorefront.aboutUs || !get(item, 'seller.isMakerOrManufacturer')) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-maker" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <FormattedMessage
                    id="PdpSharedDescriptionAboutMaker.aboutMakerHeader"
                    defaultMessage="About The Maker"
                />
            </h2>
            <PdpSharedMakerHeadshotModule seller={item.seller} liveStorefront={liveStorefront} />
            <ExpandableContent
                className={classNames(styles.content, contentClass)}
                buttonClassName={styles.button}
                collapseHeight={144}
            >
                {liveStorefront.aboutUs}
            </ExpandableContent>
        </div>
    );
}

PdpSharedDescriptionAboutMakerComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAboutMaker = createFragmentContainer(
    PdpSharedDescriptionAboutMakerComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAboutMaker_item on Item {
                seller {
                    isMakerOrManufacturer
                    sellerProfile {
                        company
                    }
                    sellerPreferences {
                        urlLabel
                    }
                    liveStorefrontProfile {
                        status
                        aboutUs
                        photos {
                            path
                            type {
                                name
                            }
                        }
                    }
                }
            }
        `,
    }
);
